import { useEffect, useState } from "react";
import closeIcon from "../../../assets/image/close.png";
import {
  useAddAssignmentMutation,
  useEditAssignmentMutation,
  useGetAssignmentQuery,
} from "../../../features/assignments/assignmentsApi";
import { useGetVideosQuery } from "../../../features/videos/videosApi";
import Error from "../../ui/Error";

export default function VideoModal({ open, control, task, assignmentId }) {
  const [checkAssignmentId, setCheckAssignmentId] = useState(false);
  const { data: assignment } =
    useGetAssignmentQuery(assignmentId, {
      skip: !checkAssignmentId,
    }) || {};

  const {
    title: initialTitle,
    video_id: initialVideoId,
    video_title: initialVideoTitle,
    totalMark: initialTotalMark,
    id,
  } = assignment || "";

  useEffect(() => {
    if (assignmentId !== undefined) {
      setCheckAssignmentId(true);
    }
  }, [assignmentId]);

  useEffect(() => {
    setTitle(initialTitle);
    setVideoId(initialVideoId);
    setVideoTitle(initialVideoTitle);
    setTotalMark(initialTotalMark);
  }, [initialTitle, initialVideoId, initialTotalMark, initialVideoTitle]);

  const [title, setTitle] = useState(initialTitle || "");
  const [videoId, setVideoId] = useState(initialVideoId || "");
  const [videoTitle, setVideoTitle] = useState(initialVideoTitle || "");
  const [totalMark, setTotalMark] = useState(initialTotalMark || "");

  const [addAssignment, { isLoading, isSuccess, isError, error }] =
    useAddAssignmentMutation();

  const { data: videos } = useGetVideosQuery() || {};

  const [
    editAssignment,
    {
      isLoading: editLoading,
      isSuccess: editIsSuccess,
      isError: editIsError,
      error: editError,
    },
  ] = useEditAssignmentMutation();

  useEffect(() => {
    if (isSuccess || editIsSuccess) {
      control();
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (task === "Add") {
      addAssignment({
        data: {
          title,
          video_id: videoId,
          video_title: videoTitle,
          totalMark,
        },
      });
    } else if (task === "Edit") {
      editAssignment({
        id,
        data: {
          title,
          video_id: videoId,
          video_title: videoTitle,
          totalMark,
        },
      });
    }
  };

  const handleVideo = (e) => {
    setVideoId(e.target.value);
    setVideoTitle(e.target.selectedOptions[0].text);
  };

  return (
    open && (
      <>
        <div
          onClick={control}
          className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"
        ></div>
        <div className="rounded w-[400px] lg:w-[600px] space-y-8 text-white bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
          <button
            className="absolute close-icon bg-transparent text-white font-bold text-xl focus:outline-none"
            onClick={control}
          >
            <img src={closeIcon} alt="Close Icon" />
          </button>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-white">
            {task} Assignment
          </h2>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <label htmlFor="title" className="sr-only">
                  Assignment Title
                </label>
                <input
                  id="title"
                  name="title"
                  type="text"
                  required
                  className="my-4 appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-black rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Assignment Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
              <div>
                <label
                  htmlFor="video-title"
                  className="sr-only block text-gray-700 font-bold mb-2"
                >
                  Assignment for Video
                </label>
                <select
                  id="video-title"
                  name="video-title"
                  required
                  className="my-4 appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-black rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  value={videoId}
                  onChange={(e) => handleVideo(e)}
                >
                  <option value="" className="placeholder-gray-500">
                    Select Video for Assignment
                  </option>
                  {videos?.map((video) => {
                    if (video.id === videoId) {
                      return (
                        <option key={video.id} value={video.id} selected>
                          {video.title}
                        </option>
                      );
                    } else {
                      return (
                        <option key={video.id} value={video.id}>
                          {video.title}
                        </option>
                      );
                    }
                  })}
                </select>
              </div>
              <div>
                <label htmlFor="total-mark" className="sr-only">
                  Total Mark
                </label>
                <input
                  id="total-mark"
                  name="total-mark"
                  type="number"
                  required
                  className="my-4 appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-black rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Total Mark e.g. max.100"
                  value={totalMark}
                  onChange={(e) => setTotalMark(e.target.value)}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                disabled={isLoading || editLoading}
              >
                {task === "Add" ? "Add" : "Edit"} Video
              </button>
            </div>

            {isError && <Error message={error?.data} />}
            {editIsError && <Error message={editError?.data} />}
          </form>
        </div>
      </>
    )
  );
}
